import { render } from "./profile-setting.vue?vue&type=template&id=27e304c8"
import script from "./profile-setting.vue?vue&type=script&lang=js"
export * from "./profile-setting.vue?vue&type=script&lang=js"

import "./profile-setting.vue?vue&type=style&index=0&id=27e304c8&lang=css"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__